"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInWithProviderButtons = void 0;
const SignInWithProviderButton_1 = require("root/src/client/v2/auth/components/SignInWithProviderButton");
const providers_1 = require("root/src/shared/@types/providers");
const useUserData_1 = require("root/src/client/v2/userData/hooks/useUserData");
function SignInWithProviderButtons(params) {
    var _a, _b, _c;
    const { userData, isLoading } = (0, useUserData_1.useUserData)();
    return (<>
			<SignInWithProviderButton_1.SignInWithProviderButton provider={providers_1.Provider.Twitch} isLinking={params.isLinking} disabled={!!((_a = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _a === void 0 ? void 0 : _a.twitchData) || isLoading}>
				Sign in with Twitch
			</SignInWithProviderButton_1.SignInWithProviderButton>
			<SignInWithProviderButton_1.SignInWithProviderButton provider={providers_1.Provider.Google} isLinking={params.isLinking} disabled={!!((_b = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _b === void 0 ? void 0 : _b.youtubeData) || isLoading}>
				Sign in with YouTube
			</SignInWithProviderButton_1.SignInWithProviderButton>
			<SignInWithProviderButton_1.SignInWithProviderButton provider={providers_1.Provider.TikTok} isLinking={params.isLinking} disabled={!!((_c = userData === null || userData === void 0 ? void 0 : userData.creatorData) === null || _c === void 0 ? void 0 : _c.tiktokData) || isLoading}>
				Sign in with TikTok
			</SignInWithProviderButton_1.SignInWithProviderButton>
		</>);
}
exports.SignInWithProviderButtons = SignInWithProviderButtons;
